import Pikaday from '../../vendor/pikaday';

export function datepicker(element, trigger) {
	const MODE_DATE = 'date';
	const MODE_MONTH = 'month';

	const dateInput = element.querySelector('[name="date"]');

	let calendar;
	let searchMode;
	let isOpen = false;

	const setButton = element.querySelector('.js-dp-set');
	const clearButton = element.querySelector('.js-dp-clear');
	const modeButton = element.querySelector('.js-dp-switch');
	const monthInputs = Array.from(element.querySelectorAll('input[name="months[]"]'));

	const date = element.querySelector('.js-dp-date');
	const month = element.querySelector('.js-dp-month');

	setButton.addEventListener('click', setMonths);
	clearButton.addEventListener('click', reset);
	modeButton.addEventListener('click', toggleMode);

	// Prevent onscreen keyboard on iOS, Android, etc.
	trigger.setAttribute('readonly', true);

	searchMode = element.dataset.mode;

	if (searchMode == MODE_MONTH) {
		setMonths();
		switchToMonthView();
	}

	function enableCalendar() {
		if (calendar != undefined) {
			return;
		}

		date.hidden = false;

		return calendar = new Pikaday({
			bound: false,
			container: element.querySelector('.js-dp-date'),
			field: trigger,
			firstDay: 1,
			theme: 'date-picker',
			format: 'DD-MM-YYYY',
			minDate: new Date(),
			onSelect: setDate,
			toString(date) {
				const year = date.getFullYear();
				const month = `${date.getMonth() + 1}`.padStart(2, 0);
				const day = `${date.getDate()}`.padStart(2, 0);

				return [day, month, year].join('-');
			},
			parse(dateString) {
				const parts = dateString.split('/');
				const day = parseInt(parts[0], 10);
				const month = parseInt(parts[1], 10) - 1;
				const year = parseInt(parts[2], 10);

				return new Date(year, month, day);
			},
		});
	}

	function disableCalendar() {
		if (calendar == undefined) {
			return;
		}

		calendar.destroy();
		calendar = undefined;
		date.hidden = true;

		return;
	}

	function show() {
		if (isOpen) {
			return;
		}

		if (searchMode == MODE_DATE) {
			switchToDateView();
		}

		if (searchMode == MODE_MONTH) {
			switchToMonthView();
		}

		isOpen = true;

		element.style.display = 'block';
		document.addEventListener('keydown', onKeydown);
		document.addEventListener('click', onDocumentClick);
	}

	function hide() {
		if (!isOpen) {
			return;
		}

		isOpen = false;
		disableCalendar();

		element.style.display = 'none';
		document.removeEventListener('keydown', onKeydown);
		document.removeEventListener('click', onDocumentClick);
	}

	function toggle() {
		isOpen ? hide() : show();
	}

	function disableModeSwitcher() {
		modeButton.hidden = true;
		modeButton.disabled = true;
	}

	function enableModeSwitcher() {
		modeButton.hidden = false;
		modeButton.disabled = false;
	}

	function reset() {
		const inputs = Array.from(element.querySelectorAll('input'));

		dateInput.value = '';
		inputs.forEach(input => input.checked = false);

		// We default to date search
		trigger.value = element.dataset.defaultDate;
		dateInput.value = element.dataset.defaultDate;
	}

	function setDate() {
		const inputs = Array.from(element.querySelectorAll('input'));
		inputs.forEach(input => input.checked = false);

		dateInput.value = calendar.toString();
		trigger.value = calendar.toString();

		hide();
	}

	function setMonths() {
		dateInput.value = '';

		const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

		const selectedDates = monthInputs.filter(input => input.checked == true);
		const selectedMonths = selectedDates.map(input => months[parseDate(input.value).getMonth()]);

		let displayValue = selectedMonths.slice(0, 2).join(', ');

		if (selectedMonths.length == 0) {
			reset();

			return;
		}

		if (selectedMonths.length > 2) {
			displayValue += ` + ${selectedMonths.length - 2} more`;
		}

		trigger.value = displayValue;

		hide();

		function parseDate(date) {
			let parts = date.split('/');

			return new Date(parts[1], parts[0] - 1);
		}
	}

	function switchToDateView() {
		date.hidden = false;
		month.hidden = true;

		if (dateInput.value == '') {
			reset();
		}

		enableCalendar();

		searchMode = MODE_DATE;
		element.dataset.mode = searchMode;
		modeButton.innerHTML = 'Or Search by month <svg class="link-icon" width="12" height="8"><path d="M6 0l3 2.5L6 5V3H0V2h6V0z"></path></svg>';
	}

	function switchToMonthView() {
		disableCalendar();

		date.hidden = true;
		month.hidden = false;

		searchMode = MODE_MONTH;
		element.dataset.mode = searchMode;
		modeButton.innerHTML = '<svg width="9" height="5"><path d="M3 0L0 2.5 3 5V3h6V2H3V0z" fill="#636363"></svg>&nbsp; Back to search by date';
	}

	function toggleMode() {
		searchMode == MODE_DATE ? switchToMonthView() : switchToDateView();
	}

	function onKeydown(event) {
		if (event.key == 'Escape') {
			hide();
		}
	}

	function onDocumentClick(event) {
		if (element.contains(event.target) || trigger.contains(event.target)) {
			return;
		}

		hide();
	}

	return {
		show,
		hide,
		toggle,
		switchToDateView,
		switchToMonthView,
		enableModeSwitcher,
		disableModeSwitcher,
	};
}
